<script setup lang="ts">
import type { PinInputInputProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { PinInputInput, useForwardProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<PinInputInputProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
    <PinInputInput
        v-bind="forwardedProps"
        :class="
            cn(
                'focus:ring-ring border-input relative flex h-10 w-10 items-center justify-center rounded-md border text-center text-sm transition-all focus:relative focus:z-10 focus:outline-none focus:ring-2',
                props.class,
            )
        " />
</template>
